// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f6fd3966","453":"19cc3d16","732":"465e1d5e","977":"6c6ca8d3"}[chunkId] + ".chunk.js";
};